import React, { useContext } from 'react';
import { LANGUAGES, LanguageContextData, ProceedableProps } from './types';
import { textValues, LanguageContext } from './utils';

const LanguageSelection = ({ proceed }: ProceedableProps) => {
  const { language, setLanguage } = useContext<LanguageContextData>(LanguageContext);

  return (
    <article>
      <h1>{ textValues[language]['languageSelection'] }</h1>
      <p>{ textValues[language]['languageSelectionText'] }</p>
      <div className='center'>
        { Array.from(LANGUAGES.keys()).map((l, index) => (
          <div key={ index }>
            <input type='radio' id={ l } name='language' value={ l } defaultChecked={ l === language } onClick={ () => setLanguage(l) } />
            <label htmlFor={ l }>{ LANGUAGES.get(l) }</label>
          </div>
        )) }
      </div>
      <div className='row'>
        &nbsp;
        <button onClick={(e) => { e.preventDefault(); proceed() }}>{ textValues[language]['languageSelectionButton'] }</button>
      </div>
    </article>
  );
};

export default LanguageSelection;